<template>
  <v-container fluid class="pa-0">
    <v-overlay :value="isLoading" absolute>
      <div class="d-flex flex-column align-center justify-center">
        <v-progress-circular indeterminate size="64" :width="5" />
        <span class="my-4">กำลังโหลดข้อมูล</span>
      </div>
    </v-overlay>

    <BoardBanner />
    <BoardRecommend :items="recommendItems" :is-loading="isLoadingRecommend" />
    <BoardCommunity :items="communityItems" :is-loading="isLoadingCommunity" />
    <BoardRegister />
  </v-container>
</template>

<script>
import BoardBanner from "@/components/Board/BoardBanner.vue";
import BoardRecommend from "@/components/Board/BoardNew.vue";
import BoardCommunity from "@/components/Board/BoardCommunity.vue";
import BoardRegister from "@/components/Board/BoardRegister.vue";
import {
  getRecommendBoardsApi,
  getCommunityBoardsApi,
} from "@/services/api/board";

export default {
  name: "Board",

  components: {
    BoardBanner,
    BoardRecommend,
    BoardCommunity,
    BoardRegister,
  },

  data() {
    return {
      isLoading: false,
      isLoadingRecommend: false,
      isLoadingCommunity: false,
      recommendItems: [],
      communityItems: [],
    };
  },

  async created() {
    await this.fetchData();
  },

  methods: {
    async fetchData() {
      this.isLoading = true;
      try {
        await Promise.all([
          this.fetchRecommendBoards(),
          this.fetchCommunityBoards(),
        ]);
      } finally {
        this.isLoading = false;
      }
    },

    async fetchRecommendBoards() {
      this.isLoadingRecommend = true;
      try {
        const res = await getRecommendBoardsApi(8);
        this.recommendItems = res.data?.data || [];
      } catch (e) {
        console.error("getRecommendBoardsApi error:", e);
      } finally {
        this.isLoadingRecommend = false;
      }
    },

    async fetchCommunityBoards() {
      this.isLoadingCommunity = true;
      try {
        const res = await getCommunityBoardsApi(4);
        this.communityItems = res.data?.data || [];
        // console.log('communityItems',this.communityItems);
        
      } catch (e) {
        console.error("getCommunityBoardsApi error:", e);
      } finally {
        this.isLoadingCommunity = false;
      }
    },
  },
};
</script>

<style scoped>
.v-container {
  padding: 0 !important;
}
</style>